export default __webpack_public_path__ + "static/media/wfis-x75.a5603ced.png";